import React, {
	useEffect,
	useMemo,
	useRef,
	useState,
} from 'react';

import GraphicMenuItem from './graphic-menu-item';
import { CssPosition } from '../../stores/types/types';
import { MenuItem } from '../general-components/right-click-menu';
import { menuPositionToStyle } from '../../utils/utils';

interface ContextMenuProps {
	menuItems: MenuItem[];
	menuPosition: CssPosition;
	isShowing: boolean;
	clickInitiator: React.MutableRefObject<HTMLElement | null>;
	onMenuBlur: () => void;
	subMenuPortalTargetId?: string;
}

export default function ContextMenu({
	menuItems,
	menuPosition,
	isShowing,
	clickInitiator,
	onMenuBlur,
	subMenuPortalTargetId,
}: ContextMenuProps) {
	const [hoveredItemKey, setHoveredItemKey] = useState<string | null>(null);

	const menuRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const clickHandler = (e: MouseEvent) => {
			const target = e.target as Node;

			if (
				menuRef.current
				&& clickInitiator?.current
				&& target
				&& !menuRef.current.contains(target)
				&& !clickInitiator.current.contains(target)
			) {
				onMenuBlur();
			}
		};

		document.addEventListener('mousedown', clickHandler);

		return () => {
			document.removeEventListener('mousedown', clickHandler);
		};
	}, [menuRef, clickInitiator]);

	const filteredMenuItems = useMemo(
		(): MenuItem[] => menuItems.filter((item) => !item.hidden),
		[menuItems],
	);

	const menuPositionStyle = useMemo(
		(): React.CSSProperties => menuPositionToStyle(menuPosition),
		[menuPosition],
	);

	return isShowing ? (
		<div className="graphic-menu-container" style={menuPositionStyle}>
			<div className="graphic-menu field-group select" ref={menuRef} onClick={onMenuBlur}>
				{filteredMenuItems.map((item, i) => {
					const key = `st-click-menu-item-${i}`;

					return (
						<GraphicMenuItem
							id={key}
							item={item}
							setHoveredItemKey={setHoveredItemKey}
							hoveredItemKey={hoveredItemKey}
							key={key}
							multipleItems={filteredMenuItems.length > 1}
							subMenuPortalTargetId={subMenuPortalTargetId}
						/>
					);
				})}
			</div>
		</div>
	) : (
		<></>
	);
}
